import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';

const SvgTag = styled.svg`
  width: 100%;
  height : 100%;
`;

export const Svg = () => {
  const state = useSelector((state) => state);
  
  const svgRef = useRef();

  const [position, setPosition] = useState({x : 1920 * 0.5, y : 1080 * 0.5});
  const [screen, setScreen] = useState({x: 0, y : 0});
  const [isDown, setIsDown] = useState(false);

  const onMouseDown = (e, type) => {
    e.preventDefault();
    
    setIsDown(true);
    
    if (type === 'M') {
      setScreen({x : e.targetTouches[0].clientX / state.common.zoom, y : e.targetTouches[0].clientY / state.common.zoom});
    } else {
      setScreen({x : e.screenX / state.common.zoom, y : e.screenY / state.common.zoom});
    }
  };

  const onMouseMove = (e, type) => {
    e.preventDefault();

    var shiftX = 0;
    var shiftY = 0;
    
    if (type === 'M') {
      shiftX = e.targetTouches[0].clientX / state.common.zoom - screen.x;
      shiftY = e.targetTouches[0].clientY / state.common.zoom - screen.y;
    } else {
      shiftX = e.screenX / state.common.zoom - screen.x;
      shiftY = e.screenY / state.common.zoom - screen.y;
    }
    
    if (isDown) {
      setPosition({x : position.x + shiftX, y : position.y + shiftY});
      if (type === 'M') {
        setScreen({x : e.targetTouches[0].clientX / state.common.zoom, y :  e.targetTouches[0].clientY / state.common.zoom});
      } else {
        setScreen({x : e.screenX / state.common.zoom, y : e.screenY / state.common.zoom});
      }
    }
  };

  const onMouseUp = (e) => {
    e.preventDefault();
    
    setIsDown(false);
    setScreen({x : 0, y : 0});
  };

  return (
    <SvgTag ref={svgRef}>
      <mask id="myMask">
        <rect x="0" y="0" width="100%" height="100%" fill="white"></rect>
        <circle
          cx={position.x}
          cy={position.y}
          r="150px" 
          fill="black"
        />
      </mask>
      <rect
        x="0" 
        y="0" 
        width="100%" 
        height="100%" 
        fill="#000" 
        mask="url(#myMask)"
        onMouseDown={(e) => onMouseDown(e, "")}
        onMouseUp={(e) => onMouseUp(e, "")}
        onMouseMove={(e) => onMouseMove(e, "")}
        onTouchStart={(e) => onMouseDown(e, "M")}
        onTouchEnd={(e) => onMouseUp(e, "M")}
        onTouchMove={(e) => onMouseMove(e, "M")}
      />
    </SvgTag>
  );
};  